<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'SALECOMPANY_LIST.TITLE_1' | translate }}</h3>
  <div class="text-center">
    <div class="text-center finish">
      {{ 'SALECOMPANY_LIST.REG_COMP_TEXT_APPLY' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()" class="btn-grey" style="padding: 11px 26px">
            {{ 'SALECOMPANY_LIST.RETURN_LIST_APPLY_REGIST' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>